import {
  Box,
  Image,
  Text,
  VStack,
  usePrefersReducedMotion,
  SlideFade,
  ScaleFade,
} from "@chakra-ui/react";
import { useGetOrderMediaConfig } from "../../PlaceOrderTest/queryHooks";


const GaraazEventNotification = () => {
  const { data: mobileConfig } = useGetOrderMediaConfig();
  const garaaz_event_config: any = JSON.parse(
    mobileConfig?.garaaz_event_config
  );
  const gifUrl = garaaz_event_config.gifUrl;
  const message = garaaz_event_config.message;
  const subMessage = garaaz_event_config.subMessage;
  const prefersReducedMotion = usePrefersReducedMotion();
  const isVisible = true;

  if (!gifUrl) return null;

  return (
    <SlideFade in={isVisible}>
      <VStack 
        spacing={4} 
        width="100%" 
        maxWidth="600px"
        margin="0 auto"
        padding={4}
        marginBottom={4}
      >
        <Box textAlign="center" width="100%">
          <Text
            fontSize="2xl"
            fontWeight="bold"
            bgGradient="linear(to-r, #4F3CC9, #7C3AED)"
            bgClip="text"
            mb={2}
          >
            {message}
          </Text>
          {subMessage && (
            <Text fontSize="md" color="gray.600" mb={4}>
              {subMessage}
            </Text>
          )}
          <ScaleFade in={isVisible}>
            <Box
              height="120px"
              position="relative"
              borderRadius="xl"
              overflow="hidden"
              boxShadow="2xl"
              transition="transform 0.2s"
              _hover={{ transform: prefersReducedMotion ? undefined : 'scale(1.02)' }}
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(45deg, rgba(79, 60, 201, 0.1), rgba(124, 58, 237, 0.1))",
                zIndex: 1,
              }}
            >
              <Image 
                src={gifUrl} 
                alt="Celebration"
                width="100%"
                height="120px"
                maxHeight={"100%"}
                objectFit="cover"
              />
            </Box>
          </ScaleFade>
        </Box>
      </VStack>
    </SlideFade>
  );
};

export default GaraazEventNotification;
